import { state } from "../state"
import { data } from "../ooss"

/* Class Cobertura */
export class CoberturaPage extends HTMLElement {

    connectedCallback() {
        this.render();
        state.dataMutuales(data);
    }

    render() {
        this.className = 'cobertura-page';
        this.innerHTML =
        `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">

                    <div class="body__cuerpo cobertura__info">
                        <div class="cobertura__text">
                            <h3 class="body__cuerpo-text-title">Obras Sociales</h3>
                            <h5 class="body__cuerpo-text-subtitle">El Sanatorio Privado Río Cuarto atiende a las siguientes obras sociales y prepagas. Para conocer las modalidades de atención de la cobertura médica que poseas, deberás consultar a la misma dónde te informarán las condiciones para atenderte en nuestra Institución.</h5>
                        </div>
                    </div>

                    <div class="body__mutuales-container">
                        <template class="mutuales__template">
                            <div class="mutuales__container">
                                <h3 class="mutuales__info">Mutual</h3>
                            </div>
                        </template>
                    </div>

                </div>
            </div>
        </div>
        `
    }
}

/* Define */
customElements.define("cobertura-page", CoberturaPage)
